import { Stack, Typography } from "@mui/material";
import { LicenseForm } from "Components/Users/UserDetailPageContent/Components/LicenseForm/LicenseForm";
import type { PartyLicenseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Licenses;

type LicensesProps = {
  licenses: Array<PartyLicenseDto>;
  partyPublicID: string;
};

export const Licenses = ({ licenses, partyPublicID }: LicensesProps) => {
  const { t } = useResource();

  if (licenses.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary">
        {t(COMPONENT_RESOURCES.Empty)}
      </Typography>
    );
  }

  return (
    <Stack gap="1rem">
      {licenses.map((license) => (
        <LicenseForm
          key={license.publicID}
          license={license}
          partyPublicID={partyPublicID}
        />
      ))}
    </Stack>
  );
};
